module.exports = "<div class=\"ot-not-found\">\n<div class=\"container-fluid\">\n  <div class=\"row\">\n    <div class=\"page-container\">\n        <h1>{{\"NOT_FOUND.PAGE_TITLE\" | translate}}</h1>\n    </div>\n  </div>\n</div>\n  <ot-footer></ot-footer>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/components/notFound.html
 ** module id = 244
 ** module chunks = 1
 **/